var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    clipPath: "url(#clip0_452_3028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90039 1.4834L14.3784 2.70073C14.6831 2.76873 14.9004 3.03873 14.9004 3.3514V10.0094C14.9004 11.3467 14.2317 12.5961 13.1191 13.3374L8.90039 16.1501L4.68172 13.3374C3.56839 12.5954 2.90039 11.3467 2.90039 10.0101V3.3514C2.90039 3.03873 3.11772 2.76873 3.42239 2.70073L8.90039 1.4834ZM8.90039 2.8494L4.23372 3.88607V10.0094C4.23372 10.9007 4.67906 11.7334 5.42106 12.2281L8.90039 14.5481L12.3797 12.2281C13.1217 11.7334 13.5671 10.9014 13.5671 10.0101V3.88607L8.90039 2.85006V2.8494ZM11.8684 6.29806L12.8117 7.24073L8.56906 11.4834L5.74039 8.65473L6.68306 7.71207L8.56839 9.5974L11.8684 6.2974V6.29806Z",
    fill: "#565457"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_3028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.900391 0.816406)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.8e12c40060057ccf0c7d8e6d823c14c2.svg";
export { ForwardRef as ReactComponent };